import { NgModule } from '@angular/core';
import {CommonModule} from '@angular/common';
import {MtiColorHoverItemDirective} from './directivas/mti-color-hover.directive';

@NgModule({
  declarations : [
    MtiColorHoverItemDirective
  ],
  imports: [
    CommonModule
  ],
  exports: [
    MtiColorHoverItemDirective,
  ],
})
export class DirectivasModule { }
